import { TFunction } from 'i18next'

import { FooterSectionText } from '../types/footer'
import { useLocales } from '@/shared/hooks/useLocales'

interface SectionData {
  title: string
  textsList: FooterSectionText[][]
}

export const useFooterSections = (
  t: TFunction<'translation', undefined>,
  openSettings: () => void,
): {
  aboutCompanySection: SectionData
  csSection: SectionData
} => {
  const { isLocale } = useLocales()

  const aboutCompanySection: SectionData = {
    title: t('common.footer.company.title'),
    textsList: [
      [
        {
          value: t('common.footer.inquiry.marketing.text'),
          url: t('common.footer.inquiry.marketing.link'),
          key: 'inquiry.marketing',
        },
      ],
      isLocale.US || isLocale.TH
        ? []
        : [
            {
              value: t('common.footer.inquiry.application.text'),
              url: t('common.footer.inquiry.application.link'),
              key: 'inquiry.application',
            },
          ],
      [
        {
          value: t('common.footer.cs.terms.text'),
          url: t('common.footer.cs.terms.link'),
          key: 'cs.terms',
        },
      ],
      [
        {
          value: t('common.footer.inquiry.recruit.text'),
          url: t('common.footer.inquiry.recruit.link'),
          key: 'inquiry.recruit',
        },
      ],
      [
        {
          value: t('common.footer.cs.location.text'),
          url: t('common.footer.cs.location.link'),
          key: 'cs.location',
        },
      ],
      [
        {
          value: t('common.footer.cs.privacy.text'),
          url: t('common.footer.cs.privacy.link'),
          key: 'cs.privacy',
        },
      ],
      isLocale.US && isLocale.TH
        ? [
            {
              value: 'Your Privacy Choices',
              onClick: () => {
                openSettings()
              },
              key: 'your.privacy.choices',
            },
          ]
        : [],
    ],
  }

  const csSection: SectionData = {
    title: t('common.footer.cs.title'),
    textsList: [
      [
        {
          value: t('common.footer.cs.email.address'),
          url: t('common.footer.cs.email.link'),
          key: 'cs.email',
        },
      ],
    ],
  }

  return { aboutCompanySection, csSection }
}
